module.exports = __webpack_public_path__ + "static/img/wechat.08c2b44.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/wechat.png
// module id = DrZ7
// module chunks = 8